/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-11-16 09:06:01
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-11-16 13:54:20
 */
import Vue from 'vue';

// 使用 Event Bus
const bus = new Vue();

export default bus;
